<section class="faixa" [class.carregando]="carregando">
  <div class="cabeca">
    <div class="total">
      <strong>{{ numero(total) }}</strong>
      <span>clientes com telefone</span>
    </div>
    <div class="saude" *ngIf="total">
      <span class="saude-item bom"><i></i><b>{{ pctEmDia }}%</b> comprando em dia</span>
      <span class="saude-item atencao"><i></i><b>{{ pctAtencao }}%</b> esfriando ou sumidos</span>
    </div>
  </div>

  <div class="barra-base" *ngIf="total; else barraVazia">
    <span *ngFor="let fatia of fatias" class="fatia" [style.flex-grow]="fatia.qtde" [style.background]="fatia.cor"
          [title]="fatia.nome + ': ' + numero(fatia.qtde) + ' (' + fatia.pct + '%)'"></span>
  </div>
  <ng-template #barraVazia><div class="barra-base vazia"></div></ng-template>

  <div class="segmentos" role="tablist" aria-label="Segmentos de clientes">
    <button *ngFor="let item of itens" type="button" class="seg" role="tab"
            [class.ativo]="item.codigo === selecionado" [attr.aria-selected]="item.codigo === selecionado"
            [style.--cor]="item.cor" [style.--fundo]="item.fundo" [title]="item.quem"
            (click)="selecione.emit(item.codigo)">
      <span class="icone"><i [class]="item.icone"></i></span>
      <span class="texto">
        <span class="nome">{{ item.nome }}</span>
        <span class="linha-num"><strong>{{ numero(item.qtde) }}</strong><em>{{ item.pct }}%</em></span>
      </span>
    </button>
  </div>
</section>
